import { router } from '@inertiajs/react';
import { route } from '../../utils/route';
import type { IaConnection } from '../../types/ia-landing';

/** The assistants a customer connected, each one disconnectable. Used on /ia and /perfil. */
export function ConnectionsList({ connections }: { connections: IaConnection[] }) {
  const disconnect = (connection: IaConnection) => {
    if (!window.confirm(`¿Desconectar ${connection.client}? Va a dejar de tener acceso a tu cuenta al instante.`)) {
      return;
    }

    router.delete(route('ia.connections.destroy', { id: connection.id }), { preserveScroll: true });
  };

  if (connections.length === 0) {
    return <p className="text-gray-600">Todavía no conectaste ningún asistente.</p>;
  }

  return (
    <ul className="divide-y divide-gray-200 overflow-hidden rounded-xl border border-gray-200 bg-white">
      {connections.map((connection) => (
        <li key={connection.id} className="flex flex-wrap items-center justify-between gap-4 px-5 py-4">
          <div>
            <p className="font-semibold text-gray-900">{connection.client}</p>
            <p className="text-sm text-gray-500">
              Conectado el {connection.connected_at}
              {connection.last_used_at ? ` · último uso ${connection.last_used_at}` : ' · sin usar todavía'}
            </p>
          </div>
          <button
            type="button"
            onClick={() => disconnect(connection)}
            className="rounded-lg border border-red-200 px-4 py-2 text-sm font-semibold text-red-600 transition-colors hover:bg-red-50"
          >
            Desconectar
          </button>
        </li>
      ))}
    </ul>
  );
}
